import { useApiQuery } from "@/api/hooks/useApiQuery";
import { CreatedByType } from "@/entities/FileService/File.model";
import { getUser } from "@/entities/User/User.queries";

export function CreatorCell({
    createdByType,
    createdByUserId,
}: {
    createdByType: CreatedByType;
    createdByUserId: string;
}) {
    if (createdByType === CreatedByType.USER) {
        return <CreatedByUserCell userId={createdByUserId} />;
    }

    return (
        <div className="flex h-full items-center">
            <p className="body-s">System</p>
        </div>
    );
}

export function CreatedByUserCell({ userId }: { userId: string }) {
    const { data: user, isLoading } = useApiQuery(getUser, {
        params: { userId },
    });
    console.log("user", user);

    if (!user && isLoading)
        return <div className="h-4 w-24 animate-pulse rounded" />;

    if (!user) return <p>-</p>;

    return (
        <div className="flex h-full items-center">
            <p className="body-s">
                {user.firstName} {user.lastName}
            </p>
        </div>
    );
}
